export class SortRestoreJobBy {
    'field';
    'order';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "RestoreJobSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortRestoreJobBy.attributeTypeMap;
    }
    constructor() {
    }
}
